/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, makeObservable, observable } from 'mobx';

import { Filter } from '../../../interfaces';

import type { GridProps, GridStorageActions } from '../../../interfaces';
import type { GridStore } from '../grid-store';

export class FiltersStore<RowDataT, TotalRowDataT, FilterT> {
    @observable filters: Filter<FilterT>;

    constructor(
        private gridStore: GridStore<RowDataT, TotalRowDataT, FilterT>,
        props: GridProps<RowDataT, TotalRowDataT, FilterT>,
        private gridStorageActions: GridStorageActions<FilterT> | null
    ) {
        makeObservable(this);

        const filtersFromLocalStorage = gridStorageActions?.getFilterData();
        const forcedFilters = props.initialState?.isForce && props.initialState.filters;

        this.filters = forcedFilters || filtersFromLocalStorage || props.initialState?.filters || {} as Filter<FilterT>;// priority: forced initial filters => filters from localstorage => initial filters
    }

    @action.bound
    applyFilters(newFilters: Partial<Filter<FilterT>>): void {
        const filters = {
            ...this.filters,
            ...newFilters,
        };

        this.gridStore.goToPage(1);
        this.gridStorageActions?.onFilterChange(filters);
        this.filters = filters;
    }

    @action.bound
    resetFilters(): void {
        const filters = {} as Filter<FilterT>;

        this.gridStore.goToPage(1);
        this.gridStorageActions?.onFilterChange(filters);
        this.filters = filters;
    }
}
